<template>
  <div>
    <a role="button" class="btn btn-primary cbutton" @click="execSetting">設定</a>

    <div v-for="(item,index) in datas1" :key="index">
      <h1>{{item.name}} <a role="button" class="btn btn-primary" @click="gotoSubject(item)">編輯</a></h1>
      <a class="btn btn-primary dbutton" @click="DataItem_Insert(item)" v-show="isSettingEnable"><i class="fas fa-plus-circle"></i></a>
      <div class="row" style="width:800px">
        <div class="col-3" v-for="(subItem,index) in item.subItems" :key="index" >
          <a role="button" class="btn btn-primary abutton" @click="gotoMenu(subItem)">{{subItem.name}}</a>
          <a class="btn btn-danger dbutton" @click="DataItem_Remove(item)" v-show="isSettingEnable"><i class="far fa-trash-alt"></i></a>
          <a class="btn btn-primary dbutton" @click="DataItem_MoveUp(item)" v-show="isSettingEnable"><i class="fa fa-angle-up"></i> </a>
          <a class="btn btn-primary dbutton" @click="DataItem_MoveDown(item)" v-show="isSettingEnable"><i class="fa fa-angle-down"></i>  </a>
        </div>
      </div>
    </div>

    <hr>
    <div v-for="(item,index) in datas2" :key="index">
      <h1>{{item.name}}   </h1>
      <a class="btn btn-primary dbutton" @click="DataItem_Insert(item)" v-show="isSettingEnable"><i class="fas fa-plus-circle"></i></a>
      <div class="row" style="width:800px;">
        <div class="col-3" v-for="(subItem,index) in item.subItems" :key="index" >
          <a role="button" class="btn btn-primary abutton" @click="gotoMenu(subItem)">{{subItem.name}}</a>
          <a class="btn btn-danger dbutton" @click="DataItem_Remove(item)" v-show="isSettingEnable"><i class="far fa-trash-alt"></i> </a>
          <a class="btn btn-primary dbutton" @click="DataItem_MoveUp(item)" v-show="isSettingEnable"><i class="fa fa-angle-up"></i> </a>
          <a class="btn btn-primary dbutton" @click="DataItem_MoveDown(item)" v-show="isSettingEnable"><i class="fa fa-angle-down"></i> </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/**

 **/
import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";

export default {
  //name: "conentCatalog",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      isSettingEnable:false,
      datas1:[
        {
          name:"傷友基本資料",
          subItems:[
            {
              name:"受傷部位及反射情況",
              url:"",
            },
            {
              name:"泌尿系統狀況及排尿狀況",
              url:"",
            },
            {
              name:"過去曾接受過的排尿處置",
              url:"",
            },
            {
              name:"現在正在使用的藥物",
              url:"",
            },
          ]
        },
        {
          name:"現在的泌尿系統狀況",
          subItems:[
            {
              name:"現在的排尿狀況",
              url:"",
            },
            {
              name:"我的排尿處置方式非手術式及藥物介入",
              url:"",
            },
            {
              name:"我曾經接受過排尿處置相關之手術介入",
              url:"",
            },
            {
              name:"最近常發生的泌尿系統症狀",
              url:"",
            },
            {
              name:"神經性排尿障礙之藥物治療",
              url:"",
            },


          ]
        },
        {
          name:"可能的健康風險評估和處置",
          subItems:[
            {
              name:"我的排尿問題",
              url:"",
            },
            {
              name:"我所知道自己泌尿系統的狀況如何？",
              url:"",
            },
            {
              name:"我的泌尿系統併發症",
              url:"",
            },
            {
              name:"根據我的資料，我的健康風險為何？",
              url:"",
            },
            {
              name:"我應該要如何注意及改進排尿處置",
              url:"",
            },


          ]
        },
        {
          name:"我的泌尿系統症狀及處理",
          subItems:[
            {
              name:"常見的泌尿系統症狀",
              url:"",
            },
            {
              name:"我能不能改變排尿處置",
              url:"",
            },
            {
              name:"常見的泌尿系統併發症及處置",
              url:"",
            },
            {
              name:"我應該做些什麼檢查？",
              url:"",
            },
            {
              name:"我應該做些什麼檢查？",
              url:"",
            },


          ]
        },
      ],
      datas2:[
        {
          name:"定期健康檢查尋找醫院和醫師",
          subItems:[
            {
              name:"泌尿系統健康檢查項目",
              url:"",
            },
            {
              name:"危險的症狀及癥候",
              url:"",
            },
            {
              name:"我要找哪一位醫師檢查？",
              url:"",
            },
            {
              name:"重要的生活注意事項",
              url:"",
            },
            {
              name:"居家必備急救包",
              url:"",
            },

          ]
        },
        {
          name:"相關衛教資料",
          subItems:[
            {
              name:"排尿障礙的原因、檢查及治療",
              url:"",
            },
            {
              name:"脊髓損傷者常見的症狀",
              url:"",
            },
            {
              name:"尿路感染的問題",
              url:"",
            },
            {
              name:"腎臟和膀胱功能",
              url:"",
            },
            {
              name:"排尿障礙的檢查",
              url:"",
            },
            {
              name:"尿失禁的問題",
              url:"",
            },
            {
              name:"導尿和導尿管的問題",
              url:"",
            },
            {
              name:"自行導尿的問題",
              url:"",
            },
            {
              name:"排尿障礙的手術及藥物治療",
              url:"",
            },

          ]
        },
      ],

      testJson0:{
        SystemId:"",
        OrderKey: "",
        Text: "",
      },
      testMasterDetail:{
        Masters: {
          SystemId: "",
          OrderKey: "",
          Text: "Master 1",
          DetailItems: [
            {
              SystemId: "",
              OrderKey: "",
              Text: "Detail 1",
            },
          ]
        }
      },
      testMasterDetailComplex:{
        Masters: [
          {
            SystemId: "",
            OrderKey: "",
            Text: "Master 1",
            DetailItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "",
                SubDetailItems: [
                  {
                    SystemId: "",
                    OrderKey: "",
                    Text: "Detail 1",
                  },
                ]
              },
            ]
          },
        ]
      },
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    gotoSubject(item){
      this.$router.push({
        path: "/AppContentSubjectEdit",
        // path: item.url,
      });
    },
    gotoMenu(item){
      this.$router.push({
        path: "/AppContentQuestionEdit",
        // path: item.url,
      });
    },
    execSetting(){
      this.isSettingEnable=!this.isSettingEnable;
    },
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.Id,this.datas2,"Id","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.Id,this.datas2,"Id","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderAppendLast(newItem,this.datas2,"OrderKey")
    },
    DataItem_Insert(currentItem){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderInsert(newItem,currentItem,this.datas2,"Id","OrderKey")
    },
    DataItem_Remove(item){
      //this.datas2= this.exchangeRatesDemo.filter(s => s.Id !==item.Id);
    },

  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>
.abutton{
  color: white;
  width: 100%;
  height:80px;
  margin-bottom: 10px;
}
.cbutton{
  background-color: #1b9e3e;
  color: white;
  /*width: 100%;*/
  margin-bottom: 10px;
}

.dbutton{
  color: white;
  /*width: 100%;*/
  margin-bottom: 10px;
}
</style>
